import { Fragment, FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import PatientApi from "Service/Patient.api";
import Loader from "Components/Loader";
import NoData from "Components/NoData";
import { SideModalProps } from "DataTypes/Modal";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { RedoxVaccineType } from "DataTypes/Services/Patient.type";
import RedoxFormatter from "Utils/Redox.Formatter";
import DateTime from "Utils/DateTime";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import UpdateVaccine from "./UpdateVaccine";

export interface DataActionType {
  data: RedoxVaccineType | null;
  action: "ADD" | "EDIT" | "VIEW" | null;
}

const Vaccine: FC<SideModalProps> = (props) => {
  const { onClose } = props;
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const newPatientId = patientInfo.id;
  const [vaccineList, setVaccineList] = useState<RedoxVaccineType[]>([]);
  const [loading, setLoading] = useState(true);
  const [dataAction, setDataAction] =
    useState<DataActionType>({ data: null, action: null });

  useEffect(() => {
    getVaccineData();
  }, []);

  const getVaccineData: () => void = async () => {
    const res: any = await PatientApi.RedoxVaccines({ id1: newPatientId });
    if (res?.success) {
      setVaccineList(RedoxFormatter.VaccineList(res?.data?.immunizations));
    }
    setLoading(false);
  };

  const handleCloseLayer2: () => void = () => {
    setDataAction({ data: null, action: null })
  };

  const Layer1Header = (
    <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
      <Typography fontWeight="bold">Vaccines</Typography>
      <Box display={"flex"}>
        {/* <Box
          sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
          onClick={() => setDataAction({ data: null, action: "ADD" })}
        >
          <ImgPath.PlusIcon titleAccess="Add Vaccine" />
        </Box> */}
        <Box
          sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
          onClick={() => {
            handleCloseLayer2();
            onClose();
          }}
        >
          <ImgPath.CloseIcon titleAccess="Close" />
        </Box>
      </Box>
    </Box>
  );

  const Layer1List = (
    vaccineList.map((el) => {
      return (
        <Typography key={el.id} variant="body2" sx={{ mb: 1 }}>
          • {DateTime.ToLocalDate(el.dateTime)} - {el.name}
        </Typography>
      );
    })
  );

  const Layer1 = (
    <Fragment>
      {Layer1Header}
      <Box sx={{ ...sxMain }}>
        {loading ? <Loader /> : vaccineList.length ? Layer1List : <NoData />}
      </Box>
    </Fragment>
  );

  return (
    <Fragment>
      <Box width="25%">{Layer1}</Box>
      <Box width="1%"></Box>
      {dataAction.action && (
        <Box width="64%">
          <UpdateVaccine
            dataAction={dataAction}
            onClose={handleCloseLayer2}
            refreshList={getVaccineData}
          />
        </Box>
      )}
    </Fragment>
  );
};
export default Vaccine;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "90%",
  overflow: "auto",
  px: 2,
};
